"use strict";
/* @ngInject */
function layoutInitService($window, userSessionService, FEATURE_TOGGLE, insightsPopoverService) {
    return (function (initData) {
        var succeedLayout = $window.succeedLayout;
        var navigationMenu = userSessionService.getNavigationMenu();
        if (navigationMenu) {
            succeedLayout.createNav(navigationMenu.topLevelNavItems, navigationMenu.setupItems, navigationMenu.helpItems, navigationMenu.communityUrl);
        }
        var layoutUser = userSessionService.getLayoutUser();
        if (layoutUser) {
            succeedLayout.showUserInfo(layoutUser);
        }
        if (succeedLayout && succeedLayout.applyToggles) {
            succeedLayout.applyToggles(FEATURE_TOGGLE);
        }
        if (initData) {
            if (FEATURE_TOGGLE["naviance.insights.navigation_popovers"]) {
                if (initData.district ||
                    (initData.institution && (initData.institution.level === "high" || initData.institution.level === "combined"))) {
                    var accessLevel_1 = initData.district ? "district" : "school";
                    insightsPopoverService.isAnalyticsPopoverDisplayed(accessLevel_1).then(function (state) {
                        if (state) {
                            succeedLayout.displayAnalyticsPopover(initData.district ? "bottom" : "right", function () {
                                insightsPopoverService.refreshAnalyticsPopoverDisplay(accessLevel_1);
                            });
                        }
                    });
                    insightsPopoverService.isInsightsPopoverDisplayed(accessLevel_1).then(function (state) {
                        if (state) {
                            succeedLayout.displayInsightsPopover();
                        }
                    });
                }
            }
            if (succeedLayout && succeedLayout.googleTagManagerDataLayerInfo) {
                var dataLayer = {
                    userId: initData.currentUser.userId,
                    institution: initData.institution.institutionId,
                    institutionName: initData.institution.name
                };
                succeedLayout.googleTagManagerDataLayerInfo(dataLayer);
            }
        }
    });
}
exports.layoutInitService = layoutInitService;



/** WEBPACK FOOTER **
 ** ./app/layout-init/layout-init.service.ts
 **/